import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SKELETON_MAX_ROWS } from '../../../paginator/pagination.constants';

@Component({
    selector: 'page-loader',
    template: `
    @if (show || extraShowCondition) {
      @if (variant === 'skeleton') {
        <div class="loader-backdrop loader-backdrop--skeleton">
          @switch (skeletonType) {
            @case ('table') {
              <ctv-skeleton-table [rows]="skeletonRows" [columns]="skeletonColumns"></ctv-skeleton-table>
            }
            @default {
              <ctv-skeleton-card [variant]="skeletonType" [lines]="skeletonRows"></ctv-skeleton-card>
            }
          }
        </div>
      } @else {
        <div class="loader-backdrop">
          <div class="loader-content">
            <mat-spinner diameter="35"></mat-spinner>
            @if (checkIfString() && show) {
              <p class="mt-3">{{show}}</p>
            }
          </div>
        </div>
      }
    }
    <ng-content></ng-content>
    `,
    styleUrls: ['./page-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageLoader implements OnChanges {
  @Input() public show:  boolean | string;
  /** Opt-in: 'skeleton' swaps the centered spinner for a content-shaped placeholder. Default keeps the spinner. */
  @Input() public variant: 'spinner' | 'skeleton' = 'spinner';
  /** Skeleton shape (only used when variant is 'skeleton'). 'table' | 'kpi' | 'chart' | 'list'. */
  @Input() public skeletonType: 'table' | 'kpi' | 'chart' | 'list' = 'table';
  /** Rows for table, lines for list. */
  @Input() public skeletonRows = SKELETON_MAX_ROWS;
  @Input() public skeletonColumns = 5;
  @Input() public extraShowCondition: any; //this can be anything, for example sometimes we need to check if some part of html has rendered in background before disabling loader

  /** The absolute skeleton backdrop is sized by this host (via a custom property, since list-layout rules force min-height with !important); while real rows are hidden it would collapse and clip the placeholder, so reserve header + rows (44px each). */
  @HostBinding('style.--dxk-skeleton-min-height')
  public get skeletonMinHeight(): string | null {
    return (this.show || this.extraShowCondition) && this.variant === 'skeleton' && this.skeletonType === 'table'
      ? `${(Math.min(this.skeletonRows, SKELETON_MAX_ROWS) + 1) * 44}px`
      : null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.extraShowCondition) {
      console.log('Show loading: ', changes.extraShowCondition.currentValue);
    }
  }

  public checkIfString(): boolean{
    return typeof this.show === 'string';
  }

  public checkIfBoolean(): boolean{
    return typeof this.show === 'boolean';
  }
}

